import React, { Component } from 'react';
import classnames from 'classnames';

import Image from 'components/Image';
import QualityValue from 'components/QualityValue';
import buildTooltipData from '../buildTooltipData';

export class ExchangeItem extends Component {
  render() {
    const { data, onClick, quantity } = this.props;

    const { forSale, availability } = data;
    const { purchaseQuality, quality } = availability;

    const purchaseIsCurrency = purchaseQuality.category === 'Currency';

    return (
      <li
        className={classnames(
          'shop__item js-item item',
          !purchaseIsCurrency && 'extra-padding',
        )}
        data-quality-id={quality.id}
      >
        <div className="js-icon icon js-tt icon--inventory icon--emphasize">
          <Image
            defaultCursor
            icon={quality.image}
            alt={quality.name}
            type="small-icon"
            tooltipData={buildTooltipData(quality)}
            tooltipPos="right"
          />
          {quantity > 0 && (
            <span className="js-item-value icon__value">
              {quantity}
            </span>
          )}
        </div>
        <div className="item__desc">
          <span className="js-item-name item__name">
            {quality.name}
          </span>
          <QualityValue
            isCurrency={purchaseIsCurrency}
            quality={purchaseQuality}
            value={forSale ? data.availability.cost : data.availability.sellPrice}
          />
        </div>
        <div className="js-item-controls item__controls">
          <button
            className="button button--primary button--sm js-bazaar-sell"
            onClick={onClick}
            type="button"
          >
            {forSale ? 'Buy' : 'Sell'}
          </button>
        </div>
      </li>
    );
  }
}

ExchangeItem.displayName = 'ExchangeItem';

export default ExchangeItem;